<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>{{ $t("courses.detail.courseDetails") }}</h6>
      <div class="ml-4 container">
        <span class="left-span text-xl font-weight-bold"
          >{{ $t("courses.detail.courseName") }}: {{ course.title }}</span
        >
        <!-- <span class="right-span text-xl font-weight-bold"
          >{{ $t("courses.detail.courseTitle") }}: {{ course.title }}</span
        > -->
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 subcourse-title"
              >
                {{ $t("courses.detail.subcourseTitle") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.teacher") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.numberOfCandidate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("courses.detail.coursePrice") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseStartDate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.pastMonths") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.currentSubcourseProgress") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseDuration") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in course.subcourses" :key="item.id">
              <td class="subcourse-title">
                {{ item.title }}
              </td>
              <td>
                <span class="text-xs font-weight-bold mb-0">
                  {{ item.teacher[0] ? item.teacher[0].name : "" }}
                </span>
              </td>
              <td>
                <span class="text-xs font-weight-bold mb-0">
                  {{ item.kids_per_subcourse }}
                </span>
              </td>
              <td>
                <span class="text-xs font-weight-bold mb-0">
                  {{ item.price }} RSD
                </span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  item.start_date
                }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold"
                  >{{ item.number_of_finished_months }}.</span
                >
              </td>
              <td class="align-middle text-center">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="me-2 text-xs font-weight-bold"
                    >{{ item.course_progress }}%</span
                  >
                  <div>
                    <soft-progress
                      color="info"
                      variant="gradient"
                      :percentage="item.course_progress"
                    />
                  </div>
                </div>
              </td>
              <td class="align-middle ps-2">
                <span class="me-2 text-xs font-weight-bold"
                  >{{ item.number_of_months }}
                  {{ formatMonthsTitle(item.number_of_months) }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div class="m-4">
          <soft-badge
            color="warning"
            variant="gradient"
            size="sm"
            @click="$emit('close')"
            class="cursor-pointer"
          >
            {{ $t("global.close") }}
          </soft-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftProgress from "@/components/SoftProgress";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "course-details",
  components: {
    SoftProgress,
    SoftBadge,
  },
  props: {
    course: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    formatMonthsTitle(numberOfMonths) {
      return numberOfMonths > 4
        ? this.$t("teachers.detail.months")
        : this.$t("teachers.detail.month");
    },
  },
};
</script>

<style scoped>
.child-component {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.container {
  display: inline-flex;
  justify-content: flex-start;
  position: relative;
}
tr,
td {
  text-align: center;
  vertical-align: middle;
}
.subcourse-title {
  padding-left: 30px;
  text-align: left;
}
</style>
